import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const ADMIN_TOKEN_KEY = 'kalamanch_admin_token';

const adminApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Admin authentication uses an HttpOnly cookie. Keep the old helper as a
// compatibility no-op while removing any legacy token exposed to JavaScript.
export const saveAdminToken = () => {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
};

export const clearAdminToken = () => {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
};

export default adminApi;
